import { Action, PlainObject, State } from "@zyzgroup/core-common";

function reduce(state: State, payload: PlainObject): State {
  state.status = payload.status || "";
  state.title = payload.title || "";
  state.subtitle = payload.subtitle || "";
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_RESULT":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
